import { Tooltip } from 'antd'

import { useTheme } from 'styled-components'

import { useSitesStore } from '../stores/sites'
import { useUserStore } from '../stores/user'
import { getViewersTitle, PatientIdToViewers, ViewersType } from './helpers'
import { PulsatingDot } from './PulsatingDot'

export function Viewers({
  patientId,
  viewers,
  type,
}: {
  patientId?: string
  viewers: PatientIdToViewers
  type: ViewersType
}): React.ReactNode {
  const [users] = useSitesStore((state) => [state.users])
  const [ownUserId] = useUserStore((state) => [state.userId])
  const theme = useTheme()

  const patientViewers =
    (patientId ? viewers[patientId]?.filter(({ userId }) => userId !== ownUserId) : undefined) ?? []

  if (!patientViewers.length) return null

  const title = getViewersTitle(patientViewers, users, type)

  return (
    <Tooltip placement="right" title={title}>
      <PulsatingDot color={theme.primary} size={16} />
    </Tooltip>
  )
}
